module.exports = __webpack_public_path__ + "media/images/dashboard/bft_banner_card-db888de1c03d43956fdb99b47f45d26a.jpg";